import type { BrandConfig } from './brands/types'

const brand = process.env.NEXT_PUBLIC_BRAND || 'default'

let config: BrandConfig

try {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  config = require(`./brands/${brand}/${brand}.config`).default as BrandConfig
} catch (e) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  config = require('./brands/default/default.config').default as BrandConfig
}

export default config
